export type AccessPage = {
  key: string;
  label: string;
  path: string;
};

export const ACCESS_PAGES: AccessPage[] = [
  { key: "dashboard", label: "Dashboard", path: "/dashboard" },
  { key: "calendar", label: "Calendario", path: "/calendar" },
  { key: "attendants-day", label: "Agendamentos", path: "/attendants-day" },
  { key: "chat", label: "Atendimento", path: "/chat" },
  { key: "whatsapp-campaigns", label: "Campanhas WhatsApp", path: "/whatsapp-campaigns" },
  { key: "clients", label: "Clientes", path: "/clients" },
  { key: "performance", label: "Performance", path: "/performance" },
  { key: "sales", label: "Vendas", path: "/sales" },
  { key: "products", label: "Produtos", path: "/products" },
  { key: "financial-management", label: "Financeiro", path: "/financial-management" },
  { key: "configurations", label: "Configuracoes", path: "/configurations" },
  { key: "payment", label: "Pagamentos", path: "/payment" },
];

const LANDING_PAGE_PRIORITY = [
  "dashboard",
  "products",
  "sales",
  "clients",
  "payment",
  "attendants-day",
  "calendar",
  "chat",
  "whatsapp-campaigns",
  "performance",
  "financial-management",
  "configurations",
];

export const PUBLIC_PATHS = [
  "/",
  "/login",
  "/register",
  "/forgot-password",
  "/send-email-forgot-password",
  "/terms",
  "/privacy-policy",
];

export const PUBLIC_CONTENT_PATHS = [
  "/terms",
  "/privacy-policy",
];

export function normalizeAccessPages(pages: Partial<AccessPage>[] | null | undefined): AccessPage[] {
  if (!Array.isArray(pages) || pages.length === 0) {
    return ACCESS_PAGES;
  }

  return pages.map((page) => ({
    key: page.key || "",
    label: page.label || page.key || "",
    path: ACCESS_PAGES.find((item) => item.key === page.key)?.path || `/${page.key}`,
  }));
}

export function canAccessPage(allowedPages: string[] | null | undefined, pageKey?: string): boolean {
  if (pageKey === 'whatsapp-campaigns') return Array.isArray(allowedPages) && allowedPages.includes(pageKey);
  if (!pageKey) {
    return true;
  }

  if (!Array.isArray(allowedPages) || allowedPages.length === 0) {
    return true;
  }

  return allowedPages.includes(pageKey);
}

export function firstAllowedPath(allowedPages: string[] | null | undefined): string {
  const page = LANDING_PAGE_PRIORITY
    .map((key) => ACCESS_PAGES.find((item) => item.key === key))
    .find((item) => item && canAccessPage(allowedPages, item.key));

  return page ? page.path : "/dashboard";
}
